export const widgetName: string = 'calendar-box';
export const widgetDisplayName: string = 'Calendar Box';
export const widgetCategory: string = 'Reply.com';
export const widgetSelector: string = 'calendar-box';
export const widgetEditorSelector: string = 'calendar-box-editor';
export const widgetRuntimeSelector: string = 'calendarbox-runtime';